import { render, staticRenderFns } from "./AddInviteDialog.vue?vue&type=template&id=38724a6b"
import script from "./AddInviteDialog.vue?vue&type=script&lang=js"
export * from "./AddInviteDialog.vue?vue&type=script&lang=js"
import style0 from "./AddInviteDialog.vue?vue&type=style&index=0&id=38724a6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports